/**
 * Resolve entry date from customer_entries documents (handles imports / legacy shapes).
 */
export function parseEntryTimestamp(data) {
  const raw = data?.createdAt ?? data?.entryDate ?? data?.invoiceDate;
  if (raw == null || raw === "") return null;
  if (typeof raw.toDate === "function") {
    try {
      const d = raw.toDate();
      return d instanceof Date && !Number.isNaN(d.getTime()) ? d : null;
    } catch {
      return null;
    }
  }
  if (raw instanceof Date) return Number.isNaN(raw.getTime()) ? null : raw;
  if (typeof raw === "number" && Number.isFinite(raw)) {
    const d = new Date(raw);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  if (typeof raw === "object" && typeof raw.seconds === "number") {
    const d = new Date(raw.seconds * 1000);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  if (typeof raw === "string") {
    const d = new Date(raw.trim());
    return Number.isNaN(d.getTime()) ? null : d;
  }
  return null;
}
